/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_HeadingInputs */

const zh_learn_heading = /** @type {(inputs: Learn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习`)
};

const en_learn_heading = /** @type {(inputs: Learn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn`)
};

const es_learn_heading = /** @type {(inputs: Learn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprender`)
};

/**
* | output |
* | --- |
* | "Learn" |
*
* @param {Learn_HeadingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const learn_heading = /** @type {((inputs?: Learn_HeadingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_HeadingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_heading(inputs)
	if (locale === "en") return en_learn_heading(inputs)
	return es_learn_heading(inputs)
});